export const CANCEL_ALL_TASKS_WS = 'CANCEL_ALL_TASKS_WS';
export const CANCEL_ALL_TASKS_WS_SUCCESS = 'CANCEL_ALL_TASKS_WS_SUCCESS';
export const CANCEL_ALL_TASKS_WS_ERROR = 'CANCEL_ALL_TASKS_WS_ERROR';
